<template>
  <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="blue">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Completar items para Cómputo</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="4" md="3">
              <h6>N° de Posventa: {{ codgral }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <h6>Equipo: {{ equipo }}</h6>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field requiered :rules="requiredRules" label="Registró" dense v-model="registro">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field required :rules="requiredRules" label="Fecha" dense v-model="fecha"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" md="2">
              <v-text-field label="N° serie Equipo 1" dense v-model="serie1">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-text-field label="N° serie Equipo 2" dense v-model="serie2">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-text-field label="N° serie Equipo 3" dense v-model="serie3">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-text-field label="N° serie Equipo 4" dense v-model="serie4">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-text-field label="N° serie Equipo 5" dense v-model="serie5">
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-text-field label="N° serie Equipo 6" dense v-model="serie6">
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- <v-tabs background-color="#02AC66" dark show-arrows v-model="tab">
        <v-tabs-slider color="teal lighten-3"></v-tabs-slider>
        <v-tab v-for="j in parseInt(cantidadequipos)" :key="j"> EQUIPO {{ j }} </v-tab>
        <v-tab-item v-for="iteme in parseInt(cantidadequipos)" :key="iteme"> -->
      <v-card>
        <v-data-table dense :headers="header" :items="listado" locale="es-ar" class="elevation-1" :items-per-page="200"
          :footer-props="{ itemsPerPageText: 'Items por página', }" :loading="loadtable"
          loading-text="Cargando... Espere por favor" no-data-text="No hay datos disponibles">
          <!-- <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>
                    <v-row dense>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field dense v-model="numequipo1" single-line label="N° de SERIE"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field dense v-model="observaciones2" single-line label="Observaciones"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-toolbar-title>
                </v-toolbar>
              </template> -->
          <template v-slot:item.cantidad1="{ item }">
            <div class="right-input">
              <v-text-field dense v-model="item.cantidad1" single-line type="number"></v-text-field>
            </div>
          </template>
          <template v-slot:item.cantidad2="{ item }">
            <div class="right-input">
              <v-text-field dense v-model="item.cantidad2" single-line type="number"></v-text-field>
            </div>
          </template>
          <template v-slot:item.cantidad3="{ item }">
            <div class="right-input">
              <v-text-field dense v-model="item.cantidad3" single-line type="number"></v-text-field>
            </div>
          </template>
          <template v-slot:item.cantidad4="{ item }">
            <div class="right-input">
              <v-text-field dense v-model="item.cantidad4" single-line type="number"></v-text-field>
            </div>
          </template>
          <template v-slot:item.cantidad5="{ item }">
            <div class="right-input">
              <v-text-field dense v-model="item.cantidad5" single-line type="number"></v-text-field>
            </div>
          </template>
          <template v-slot:item.cantidad6="{ item }">
            <div class="right-input">
              <v-text-field dense v-model="item.cantidad6" single-line type="number"></v-text-field>
            </div>
          </template>
          <template v-slot:item.observ="{ item }">
            <v-text-field dense v-model="item.observ" single-line></v-text-field>
          </template>
        </v-data-table>
      </v-card>
      <!-- </v-tab-item>
      </v-tabs> -->
      <v-card color="blue" dark tile>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="!valid" @click.stop="guardar">Guardar</v-btn>

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<style scoped>
::v-deep .right-input input {
  text-align: right !important;
}

.v-input input {
  text-align: right !important;
}

.v-text-field__slot input {
  text-align: right;
}
</style>
<script>
import moment from "moment";
import axios from "../../../axios-auth";
import { cloneDeep } from 'lodash';
export default {
  data: (vm) => ({
    usuario: "",
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    listado: [],
    registro: "",
    prove: "",
    fecha: moment().format("DD/MM/YYYY"),
    computo: [],
    numequipo1: "",
    numequipo2: "",
    numequipo3: "",
    series: [],
    serie1: "",
    serie2: "",
    serie3: "",
    serie4: "",
    serie5: "",
    serie6: "",
    observaciones1: "",
    observaciones2: "",
    observaciones3: "",
    tab: [],
    loadtable: false,
    header: [
      {
        text: "Item",
        align: "center",
        sortable: false,
        value: "item",
      },
      {
        text: "Tipo",
        align: "center",
        sortable: false,
        value: "tipo",
      },
      {
        text: "Código",
        align: "center",
        sortable: false,
        value: "codigo",
      },
      { text: "Descripción", value: "descr", width: "30%", sortable: false },
      {
        text: "Unidad",
        align: "center",
        value: "unidad",
        sortable: false,
      },
      {
        text: "Cantidad Eq.1",
        align: "center",
        value: "cantidad1",
        width: "7%",
        sortable: false,
      },
      {
        text: "Cantidad Eq.2",
        align: "center",
        value: "cantidad2",
        width: "7%",
        sortable: false,
      },
      {
        text: "Cantidad Eq.3",
        align: "center",
        value: "cantidad3",
        width: "7%",
        sortable: false,
      },
      {
        text: "Cantidad Eq.4",
        align: "center",
        value: "cantidad4",
        width: "7%",
        sortable: false,
      },
      {
        text: "Cantidad Eq.5",
        align: "center",
        value: "cantidad5",
        width: "7%",
        sortable: false,
      },
      {
        text: "Cantidad Eq.6",
        align: "center",
        value: "cantidad6",
        width: "7%",
        sortable: false,
      },
      { text: "Observac.", value: "observ", width: "20%", sortable: false },
    ],
    header2: [
      {
        text: "Item",
        align: "center",
        sortable: false,
        value: "item",
      },
      {
        text: "Tipo",
        align: "center",
        sortable: false,
        value: "tipo",
      },
      {
        text: "Código",
        align: "center",
        sortable: false,
        value: "codigo",
      },
      { text: "Descripción", value: "descr", width: "30%", sortable: false },
      {
        text: "Unidad",
        align: "center",
        value: "unidad",
        sortable: false,
      },
      {
        text: "Cantidad",
        align: "center",
        value: "cantidad",
        width: "10%",
        sortable: false,
      },
      { text: "Observac.", value: "observ", width: "20%", sortable: false },
    ],
    header3: [
      {
        text: "Item",
        align: "center",
        sortable: false,
        value: "item",
      },
      {
        text: "Tipo",
        align: "center",
        sortable: false,
        value: "tipo",
      },
      {
        text: "Código",
        align: "center",
        sortable: false,
        value: "codigo",
      },
      { text: "Descripción", value: "descr", width: "30%", sortable: false },
      {
        text: "Unidad",
        align: "center",
        value: "unidad",
        sortable: false,
      },
      {
        text: "Cantidad",
        align: "center",
        value: "cantidad",
        width: "10%",
        sortable: false,
      },
      { text: "Observac.", value: "observ", width: "20%", sortable: false },
    ],
    listado1: [],
    listado2: [],
    listado3: [],
  }),

  props: ["visible", "codgral", "equipo", "cantidadequipos"],

  watch: {},
  computed: {
    show: {
      get() {
        this.registro = this.$store.state.nombre.toString().trim();
        this.vaciarListado();
        //console.log("llega este equipo" + this.equipo);
        if (this.equipo != null) {
          this.buscarDatosComputo();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarListado();
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("cerrar");
        }
      },
    },
  },

  methods: {
    checkItem(item) {
      console.log(item)
      return true
    },
    vaciarListado() {
      this.listado = [];
      this.serie1 = "";
      this.serie2 = "";
      this.serie3 = "";
      this.serie4 = "";
      this.serie5 = "";
      this.serie6 = "";
      this.computo = [];
    },
    buscarDatosComputo() {
      this.loadtable = true;
      // this.vaciarListado();
      // console.log("EQUIPO   " + this.equipo);
      const nombre = this.equipo;
      const codgral = this.codgral;
      let self = this;
      axios
        .get("/App/CargarDetalleComputoCodgral?", {
          params: {
            equipo: nombre,
            codgral: codgral,
          },
        })
        .then((response) => {
          self.listado = response.data.computo;
          self.serie1 = response.data.serie1;
          self.serie2 = response.data.serie2;
          self.serie3 = response.data.serie3;
          self.serie4 = response.data.serie4;
          self.serie5 = response.data.serie5;
          self.serie6 = response.data.serie6;
          // self.listado[0].list = cloneDeep(response.data);
          // self.listado1 = cloneDeep(response.data);
          // self.listado2 = cloneDeep(response.data);
          // self.listado3 = cloneDeep(response.data);
          //console.log("serie1 " + response.data.serie1)
          self.recepciono = self.$store.state.nombre.toString().trim();
          self.loadtable = false;
        })
        .catch((error) => {
          self.listado = [];
          console.log(error);
        });
    },
    guardar() {
      this.$swal({
        title: "Guardar Cómputo",
        text: "¿Desea guardar los datos del Cómputo?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.listado.forEach((element) => {
            if (
              (element.cantidad1 != "" &&
                element.cantidad1 != null &&
                element.cantidad1 != "0") ||
              (element.cantidad2 != "" &&
                element.cantidad2 != null &&
                element.cantidad2 != "0") ||
              (element.cantidad3 != "" &&
                element.cantidad3 != null &&
                element.cantidad3 != "0") ||
              (element.cantidad4 != "" &&
                element.cantidad4 != null &&
                element.cantidad4 != "0") ||
              (element.cantidad5 != "" &&
                element.cantidad5 != null &&
                element.cantidad5 != "0") ||
              (element.cantidad6 != "" &&
                element.cantidad6 != null &&
                element.cantidad6 != "0")
            ) {
              this.computo.push({
                codgral: this.codgral,
                equipo: this.equipo,
                item: element.item,
                cantidad1: element.cantidad1,
                cantidad2: element.cantidad2,
                cantidad3: element.cantidad3,
                cantidad4: element.cantidad4,
                cantidad5: element.cantidad5,
                cantidad6: element.cantidad6,
                observ: element.observ,
                costo: element.costo,
                moneda: element.moneda,
                descr: element.descr,
              });
            }
          });
          var datosSeries = {
            codgral: this.codgral,
            serie1: this.serie1,
            serie2: this.serie2,
            serie3: this.serie3,
            serie4: this.serie4,
            serie5: this.serie5,
            serie6: this.serie6,
            computo: this.computo,
          };
          let self = this;
          axios
            .post("/App/GuardaritemsComputo", datosSeries)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarListado();
              self.showAlert({
                icon: "success",
                title: "Cómputo guardado con éxito",
                vm: self,
              });
              self.$emit("cerrar");
            })
            .catch({});
        } else {
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },
};
</script>
